import { NgClass } from '@angular/common';
import {
  Component,
  ComponentFactoryResolver,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ModalService } from '@services/modal.service';
import { Subscription } from 'rxjs';
import { Modal, MODAL_DETAILS } from './modal';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [NgClass],
  templateUrl: './modal.component.html',
})
export class ModalComponent implements OnInit, OnDestroy {
  @ViewChild('container', { read: ViewContainerRef, static: false }) container!: ViewContainerRef;

  private modalSubscription?: Subscription;

  modalData?: Modal<any>;

  showModal: boolean = true;

  modalSize: 'auto' | 'compact' | 'wide' = 'auto';

  allowToClose: boolean = true;

  constructor(
    private modalService: ModalService,
    private componentFactoryResolver: ComponentFactoryResolver,
  ) {}

  ngOnInit() {
    this.modalSubscription = this.modalService.getObservable().subscribe((modalInfo) => {
      if (modalInfo.status === 'open' && modalInfo.data) {
        this.modalData = modalInfo.data;
        this.modalSize = modalInfo?.data?.details?.size ?? 'auto';
        this.allowToClose = modalInfo?.data?.details?.allowToClose ?? true;
        this.showModal = true;
        this.loadComponent(modalInfo.data.content, modalInfo.data.id, modalInfo.data.details);
      } else if (modalInfo.status === 'close') {
        this.closeModal(true);
      }
    });
  }

  ngOnDestroy() {
    this.modalSubscription?.unsubscribe();
  }

  loadComponent(component: any, index: number, details: any) {
    this.container?.clear();
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);

    const injector = Injector.create({
      providers: [
        {
          provide: MODAL_DETAILS,
          useValue: { id: index, details: details },
        },
      ],
    });

    this.container.createComponent(componentFactory, 0, injector);
  }

  closeModal(forceClose?: boolean) {
    if (this.allowToClose || forceClose) {
      this.modalData = undefined;
      this.container?.clear();
      this.showModal = false;
    }
  }
}
